import React, { useCallback, useEffect, useState } from "react";

interface PasswordValidatorProps {
  password: string;
  onChangeValid: (valid: boolean) => void;
}

const _passwordConstrain = {
  length: false,
  // uppercase: false,
  // lowercase: false,
  // numeric: false,
  // symbol: false,
};

const PasswordValidator: React.FC<PasswordValidatorProps> = ({
  password,
  onChangeValid,
}) => {
  const [passwordConstrain, setPasswordConstrain] =
    useState(_passwordConstrain);
  const [valid, setValid] = useState(false);

  const checkPasswordConstrain = (password: string) => {
    setPasswordConstrain({
      length: password.length >= 8,
      // lowercase: haveLowercase(password),
      // numeric: haveNumber(password),
      // symbol: haveSymbol(password),
      // uppercase: haveUppercase(password),
    });
  };

  const isValidPassword = useCallback(() => {
    return Object.keys(passwordConstrain).reduce((accu, current) => {
      return (
        accu && passwordConstrain[current as keyof typeof passwordConstrain]
      );
    }, true);
  }, [passwordConstrain]);

  useEffect(() => {
    checkPasswordConstrain(password);
  }, [password]);

  useEffect(() => {
    setValid(isValidPassword());
  }, [passwordConstrain, isValidPassword]);

  useEffect(() => {
    onChangeValid(valid);
  }, [valid, onChangeValid]);

  return null

  // return (
  //   <div className={classes.root}>
  //     <Box display="flex" flexDirection="column" className={classes.container}>
  //       {/* <Typography variant="caption" color="textSecondary" className={clsx({[classes.errorColor] : !!errorPassword})}>{`รหัสผ่านต้อง ${errorPassword && `( ${errorPassword} )`}`}</Typography> */}
  //       <Box display="flex" alignItems="center">
  //         <Bullet
  //           className={classes.checkIcon}
  //           checked={passwordConstrain.length}
  //         />
  //         <Typography
  //           variant="caption"
  //           color="textSecondary"
  //           className={clsx({
  //             [classes.primaryColor]: passwordConstrain.length,
  //           })}
  //         >
  //           มีความยาวอย่างน้อย 10 ตัวอักษร
  //         </Typography>
  //       </Box>
  //       <Box display="flex">
  //         <Bullet
  //           className={classes.checkIcon}
  //           checked={passwordConstrain.uppercase && passwordConstrain.lowercase}
  //         />
  //         <Typography
  //           variant="caption"
  //           color="textSecondary"
  //           className={clsx({
  //             [classes.primaryColor]:
  //               passwordConstrain.uppercase && passwordConstrain.lowercase,
  //           })}
  //         >
  //           มีอักษรภาษาอังกฤษพิมพ์เล็กและพิมพ์ใหญ่ (เช่น A,a)
  //         </Typography>
  //       </Box>
  //       <Box display="flex">
  //         <Bullet
  //           className={classes.checkIcon}
  //           checked={passwordConstrain.numeric}
  //         />
  //         <Typography
  //           variant="caption"
  //           color="textSecondary"
  //           className={clsx({
  //             [classes.primaryColor]: passwordConstrain.numeric,
  //           })}
  //         >
  //           มีตัวเลขอย่างน้อย 1 ตัว (เช่น 1)
  //         </Typography>
  //       </Box>
  //       <Box display="flex">
  //         <Bullet
  //           className={classes.checkIcon}
  //           checked={passwordConstrain.symbol}
  //         />
  //         <Typography
  //           variant="caption"
  //           color="textSecondary"
  //           className={clsx({
  //             [classes.primaryColor]: passwordConstrain.symbol,
  //           })}
  //         >
  //           มีสัญลักษณ์อย่างน้อย 1ตัว (เช่น !)
  //         </Typography>
  //       </Box>
  //     </Box>
  //   </div>
  // );
};

export default PasswordValidator;
